import { useLanguageContext } from '@/store/contexts/LanguageContext'

/**
 * Language 관련 Custom Hook
 * LanguageContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useLanguage() {
  return useLanguageContext()
}

